import { Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h3" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom>
        {t('errors.notFoundTitle')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {t('errors.notFoundDescription')}
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        {t('errors.backHome')}
      </Button>
    </Container>
  );
}
